module.exports = __webpack_public_path__ + "img/minedu_v.03c96bd7.png";